import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import useAxios from "@hooks/use-axios";
import { OPS_ENDPOINTS } from "@constants/endpoints";
import { paymentSetupSchema, toPaymentSetupPayload, toPaymentSetupValues } from "../misc/schema";

const usePaymentSetup = ({ brandId, brand, isSelfPayout, onSaved }) => {
    const { axiosInstance, loading } = useAxios({ base: "ops" });
    const [open, setOpen] = useState(false);

    const methods = useForm({
        resolver     : yupResolver(paymentSetupSchema),
        context      : { isSelfPayout },
        defaultValues: toPaymentSetupValues(brand),
        mode         : "onChange"
    });
    const { formState: { dirtyFields, isDirty, isValid } } = methods;

    // Re-seed from the latest brand each time the editor opens, so a cancelled
    // edit never carries over into the next one.
    useEffect(() => {
        if (open) methods.reset(toPaymentSetupValues(brand));
    }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

    const openEditor = () => setOpen(true);
    const closeEditor = () => setOpen(false);

    const onSubmit = methods.handleSubmit(async (values) => {
        const payload = toPaymentSetupPayload(values, dirtyFields, isSelfPayout);
        if (!Object.keys(payload).length) return;

        await axiosInstance.patch(OPS_ENDPOINTS.BRAND_PAYMENT_SETUP(brandId), payload);
        setOpen(false);
        onSaved?.();
    });

    return {
        open,
        openEditor,
        closeEditor,
        methods,
        onSubmit,
        loading,
        canSave               : isDirty && isValid,
        showDebitNoteFrequency: !isSelfPayout
    };
};

export default usePaymentSetup;
